const LOAD_DATA_JOB           = 'LOAD_DATA_JOB'
const LOAD_DATA_JOB_SUCCESS   = 'LOAD_DATA_JOB_SUCCESS'
const LOAD_DATA_JOB_FAILED    = 'LOAD_DATA_JOB_FAILED'
const UNMOUNT_DATA_JOB        = 'UNMOUNT_DATA_JOB'
const initialState = {
  loading: true,
  meta: null,
  data: null,
  message: null,
}
const jobReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DATA_JOB:
      return {
        ...state,
        loading: true,
        meta: null,
        data: null,
      }
    case LOAD_DATA_JOB_SUCCESS:
      return { 
        ...state, 
        loading: false,
        meta: action.payload.meta,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DATA_JOB_FAILED:
      return { 
        ...state, 
        loading: true,
        meta: null,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DATA_JOB:
      return { 
        ...state, 
        loading: true,
        meta: null,
        data: null,
      }
    default:
      return state
  }
}
export default jobReducer;